<!-- routes/Home.svelte -->
<script>
  import SvelteSeo from "svelte-seo";
  import config from '../files/config.json';
  //import Top from '../components/Top.svelte'
  import About from '../components/About.svelte'
  //import Contents from '../components/Contents.svelte'
  import NewContents from '../components/NewContents.svelte'
  import Download from '../components/Download.svelte'

  // 获取 <meta name="description"> 元素
  var descriptionMeta = document.querySelector('meta[name="description"]');

  // 检查是否存在 description 元素
  if (descriptionMeta) {
    // 从父节点中移除 description 元素
    descriptionMeta.parentNode.removeChild(descriptionMeta);
  }

  // 获取 <meta name="keywords"> 元素
  var keywordsMeta = document.querySelector('meta[name="keywords"]');

  // 检查是否存在 keywords 元素
  if (keywordsMeta) {
    // 从父节点中移除 keywords 元素
    keywordsMeta.parentNode.removeChild(keywordsMeta);
  }

</script>


<div>
  <SvelteSeo
    title="{config.title}"
    description="{config.description}"
    keywords="{config.keywords}"
  />
  <main id="main">
    <About />
    <NewContents />
    <Download />
  </main>
</div>
